import { Component } from '@angular/core';
import { WhiteboardGridComponent } from '../whiteboard-grid/whiteboard-grid.component';

@Component({
    selector: 'lib-whiteboard-print',
    templateUrl: './whiteboard-print.component.html',
    styleUrls: ['./whiteboard-print.component.scss'],
    standalone: false
})
export class WhiteboardPrintComponent extends WhiteboardGridComponent{

}
